// extracted by mini-css-extract-plugin
module.exports = {"map":"TitleBox_map__mnsdO","wrapper":"TitleBox_wrapper__1zmrt","top":"TitleBox_top__1K5ti","right":"TitleBox_right__1QTPj"};